import { LocalizedStringsMethods } from 'react-localization';
import LocalizedStrings  from 'react-localization';

interface IAuditLogStrings extends LocalizedStringsMethods {
    lsHomeTxt: string;
    lsAuditLogTxt: string;
    lsLogOptionTxt1: string;
    lsLogOptionTxt2: string;
    lsEnterRowsPlaceholderTxt: string;
    lsSubmitTxt: string;
    lsSearchTxt: string;
    lsSearchPlaceholderTxt: string;
    lsDateTimeTxt: string;
    lsEventTxt: string;
    lsEnterNamePlaceholderTxt: string;
    lsAuditLogsTxt: string;
    lsBackTxt: string;
    lsDwnldTxt: string;
    lsExportLogTxt: string;
    lsOkTxt: string;
    lsExportLogSuccessTxt: string;
    lsAuditLogTotalTxt: string;
}

let strings: IAuditLogStrings;
export default strings = new LocalizedStrings({
    en: {        
        lsHomeTxt: 'Home',
        lsAuditLogTxt: 'Audit Log',
        lsLogOptionTxt1: 'Last N number of rows',
        lsLogOptionTxt2: 'Date range',
        lsEnterRowsPlaceholderTxt: 'enter number of rows',
        lsSubmitTxt: 'Submit',
        lsSearchTxt: 'Search',
        lsSearchPlaceholderTxt: 'search',
        lsDateTimeTxt: 'Date & Time',
        lsEventTxt: 'Event',
        lsEnterNamePlaceholderTxt: 'Enter username',
        lsAuditLogsTxt: 'Audit Logs',
        lsAuditLogTotalTxt: 'Total {0} Audit Logs',
        lsBackTxt: 'Back',
        lsDwnldTxt: 'Download',
        lsExportLogTxt: 'Export Audit Log List',
        lsOkTxt: 'Ok',
        lsExportLogSuccessTxt: 'Audit Logs exported successfully!',   
    },
    es: {        
        lsHomeTxt: 'Casa',
        lsAuditLogTxt: 'Registro de auditoría',
        lsLogOptionTxt1: 'Último N número de filas',
        lsLogOptionTxt2: 'Rango de fechas',
        lsEnterRowsPlaceholderTxt: 'ingrese el número de filas',
        lsSubmitTxt: 'Enviar',
        lsSearchTxt: 'Buscar',
        lsSearchPlaceholderTxt: 'buscar',
        lsDateTimeTxt: 'Fecha y hora',
        lsEventTxt: 'Evento',
        lsEnterNamePlaceholderTxt: 'Introduzca su nombre de usuario',
        lsAuditLogsTxt: 'Audit Logs',
        lsAuditLogTotalTxt: 'Total {0} Audit Logs',
        lsBackTxt: 'Back',
        lsDwnldTxt: 'Download',
        lsExportLogTxt: 'Export Audit Log List',
        lsOkTxt: 'Ok',
        lsExportLogSuccessTxt: 'Audit Logs exported successfully!',   
     }
});


// WEBPACK FOOTER //
// ./src/eyeguide-localization/strings.auditlog.tsx